/* ============================================================
   ENGINE CONSTANTS — live-tracking + catch-up thresholds shared by
   the executor and the pure core (single source of truth).
   ============================================================ */

/** Acquire the LIVE badge within this drift (s). */
export const LIVE_LOCK_TOL_S = 3
/** Keep the LIVE badge until drift exceeds this (s) — Schmitt hysteresis. */
export const LIVE_LOSE_TOL_S = 5
/** Min wall-clock (ms) between drift-correcting seeks (anti stutter-loop). */
export const SEEK_COOLDOWN_MS = 1500
/** A behind-drift past this (s) is absorbed into the live lag (coast) in TRACK. */
export const LAG_DEADBAND_S = 1.5
/** A transient spin-up blip within this window (ms) doesn't drop the badge. */
export const LIVE_STALL_GRACE_MS = 2500
/** Default channel-bump hold (ms) for a looper bump scene with no derived length. */
export const BUMPER_CHANNEL_MS = 3000
/** Consecutive distinct-video failures (no genuine play between) ⇒ a systemic block (IP bot-flag),
 *  not individual dead videos → HALT instead of churning the queue. */
export const BLOCK_THRESHOLD = 3
